/**
 * BrandLoader — carregamento de tela cheia do boot (`AuthGuard`) e das rotas
 * lazy (`Router`). Desde o P18 é só um nome fino sobre `CarregandoAxiom`
 * (logo do topo pulsando, sem texto). O indicador "pensando" do chat é outra
 * coisa (prompt-kit `Loader`) e não usa isto.
 */
import { useTranslation } from 'react-i18next'
import { CarregandoAxiom } from '@/components/ui/CarregandoAxiom'

type BrandLoaderProps = {
  /** Extra classes for the wrapper (e.g. `h-screen bg-axg-bg`). */
  className?: string
  /** i18n key read by screen readers. Defaults to `common.loading`. */
  labelKey?: string
}

/** Carregamento de tela cheia do boot/rotas: delega ao componente único. */
export function BrandLoader({ className, labelKey = 'common.loading' }: BrandLoaderProps) {
  const { t } = useTranslation()
  return <CarregandoAxiom className={className} label={t(labelKey)} />
}
